import { useContentClient } from '#imports'

export function useBlogPosts() {
    const { getBlogPosts } = useContentClient()

    return getBlogPosts({ server: true })
}
